import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getIcardRequestsReportSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(300)
    const response: ResponseModel = yield call(service.getIcardRequestsReport, params)
    yield put(actions.getIcardRequestsReportSuccess(response?.data?.data))
    yield put(actions.getIcardRequestsReportFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getIcardRequestsReportFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_ICARD_REQUESTS_REPORT_START, getIcardRequestsReportSaga)
}
